var getTags = require("../../../shared/services/getTags");
var module = angular.module('octopusApp.configuration');

module.directive("eventFilter", function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      projects: '=',
      environments: '=',
      roles: '=',
      users: '=',
      tenants: '=',
      tagSets: '=',
      eventGroups: '=',
      eventCategories: '=',
      selectedFilters: '=',
      documentTypes: '='
    },
    templateUrl: 'areas/configuration/audit/views/event_filter.html',
    controller: function($scope) {
      var vm = this;


      var refreshEventGroupCategories = function () {
        if (!vm.selectedFilters)
        {
          return;
        }

        if (vm.selectedFilters.eventGroups.length > 0) {
          var selectedGroups = _.filter(vm.eventGroups, function (eventGroup) {
            return vm.selectedFilters.eventGroups.indexOf(eventGroup.Id) > -1;
          });
          var selectedEventCategoryIds = _.flatten(_.map(selectedGroups, function (selectedGroup) {
            return selectedGroup.EventCategories;
          })).join(",");
          vm.selectedFilters.selectedEventGroupCategories = getTags(selectedEventCategoryIds, vm.eventCategories, ",");
        } else {
          vm.selectedFilters.selectedEventGroupCategories = [];
        }
      };

      $scope.$watch(function () { return vm.selectedFilters ? vm.selectedFilters.eventGroups : vm.selectedFilters; }, function() {
        refreshEventGroupCategories();
      });
    },
    controllerAs: 'vm',
    bindToController: true
  };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/audit/directives/event_filter.js
// module id = 5178794431493492
// module chunks = 1